import React from 'react';
import { defaultNavigate, NavigationProvider } from './NavigationContext';

export const RouterNavigationProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <NavigationProvider navigationImplementation={{ navigate: defaultNavigate }}>
      {children}
    </NavigationProvider>
  );
};
